@for (item of toolbarItems; track item.event) {
  <div class="tt-flowchart-drag-palette_item" draggable="true" (dragend)="onDragEnd()" (dragstart)="onDragStart($event, item, iconElement)">
    <mat-icon class="tt-flowchart-drag-palette_icon" [icon]="'drag'" [iconSize]="16" />
    <img #iconElement alt="" class="tt-flowchart-drag-palette_img" [src]="item.icon" />
    <div class="tt-flowchart-drag-palette_text">
      <span class="tt-flowchart-drag-palette_title">{{ item.titleKey | transloco }}</span>
      <span class="tt-flowchart-drag-palette_description">{{ item.descriptionKey | transloco }}</span>
    </div>
  </div>
}
